import { useCallback } from 'react';

import aguid from 'lib/aguid';
import useSetDrillDowns from './useSetDrillDowns';

const useOnExcludeTermedDriversAdded = ({
  close,
  isScope,
}: {
  close: () => void;
  isScope: boolean;
}) => {
  const setDrillDowns = useSetDrillDowns({ isScope });

  const onExcludeTermedDriversAdded = useCallback(() => {
    const plate: ExcludeTermedDriversFilterPlate = {
      id: aguid(),
      type: 'ExcludeTermedDrivers',
    };
    setDrillDowns((current) => [...current, plate]);
    close();
  }, [close, setDrillDowns]);

  return onExcludeTermedDriversAdded;
};

export default useOnExcludeTermedDriversAdded;
